import React from "react";
import { FormComponent } from "./FormComponent";
import { Control, FieldValues, useController } from "react-hook-form";
import AutoSuggest from "./AutoSuggest";

/* eslint @typescript-eslint/no-explicit-any: "off" */

interface AutosuggestFieldProps<T extends FieldValues> {
	classes?: string;
	control: Control<T>;
	endpoint: string;
	label: string;
	name: string;
	onSelect?: (key: string) => void;
	placeholder?: string;
	required?: boolean;
}

export function AutosuggestField({
	classes,
	control,
	endpoint,
	label,
	name,
	onSelect,
	placeholder,
	required = false,
}: AutosuggestFieldProps<any>) {
	const {
		field: { value, onChange },
		formState: { errors },
	} = useController({
		name,
		control,
		rules: {
			required,
		},
	});

	const component = { id: name, name, label, required, errors, classes };

	const handleSuggestionSelect = (key: string, value: string) => {
		onChange(value);
		onSelect && onSelect(key);
	};

	return (
		<FormComponent {...component}>
			<AutoSuggest
				id={name}
				name={name}
				currentInput={value || ""}
				endpoint={endpoint}
				onSuggestionSelect={handleSuggestionSelect}
				onInputChange={onChange}
				placeholder={placeholder}
				searchByCode={false}
			/>
		</FormComponent>
	);
}
